import React from 'react'

/**
 * Bộ icon Reaction thiết kế SVG cao cấp phong cách 3D (Like, Love, Care, Haha, Wow, Sad, Angry)
 */
export const ReactionIcon = ({ type, size = 24, className = '', style = {} }) => {
  const iconSize = size

  switch (type) {
    case 'LIKE':
      return (
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 36 36"
          className={className}
          style={{ verticalAlign: 'middle', display: 'inline-block', ...style }}>
          <defs>
            <radialGradient id="like_bg" cx="30%" cy="30%" r="70%">
              <stop offset="0%" stopColor="#3b8aff" />
              <stop offset="60%" stopColor="#1877f2" />
              <stop offset="100%" stopColor="#0b5ecc" />
            </radialGradient>
            <linearGradient id="like_glow" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#ffffff" stopOpacity="0.4" />
              <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
            </linearGradient>
            <filter id="like_shadow" x="-10%" y="-10%" width="120%" height="120%">
              <feDropShadow dx="0" dy="1" stdDeviation="1" floodColor="#084298" floodOpacity="0.3" />
            </filter>
          </defs>
          <circle cx="18" cy="18" r="17" fill="url(#like_bg)" />
          <ellipse cx="18" cy="10" rx="11" ry="6" fill="url(#like_glow)" />
          <path
            filter="url(#like_shadow)"
            d="M10 24.5a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 1.5-1.5h2v9h-2zm4.5 0v-8.2c0-.5.2-1 .5-1.4l2.8-4.2c.5-.7 1.4-1.2 2.3-1.2.9 0 1.6.7 1.6 1.6 0 1.3-.4 2.8-.7 3.9h5.1c1.2 0 2.1 1 2 2.2l-.9 6.2c-.1 1-1 1.9-2 1.9h-8.7a2 2 0 0 1-2-1.7z"
            fill="#ffffff"
          />
        </svg>
      )

    case 'LOVE':
      return (
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 36 36"
          className={className}
          style={{ verticalAlign: 'middle', display: 'inline-block', ...style }}>
          <defs>
            <radialGradient id="love_bg" cx="35%" cy="30%" r="70%">
              <stop offset="0%" stopColor="#ff5e7e" />
              <stop offset="50%" stopColor="#f33e58" />
              <stop offset="100%" stopColor="#cc1330" />
            </radialGradient>
            <linearGradient id="love_shine" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#ffffff" stopOpacity="0.6" />
              <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
            </linearGradient>
            <filter id="love_shadow" x="-10%" y="-10%" width="120%" height="120%">
              <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#900" floodOpacity="0.25" />
            </filter>
          </defs>
          <circle cx="18" cy="18" r="17" fill="url(#love_bg)" />
          <path
            filter="url(#love_shadow)"
            d="M18 27.5s-8.5-5.3-10.3-9.9c-1.3-3.3.4-6.6 3.6-7.1 2.5-.4 4.8.8 6.7 2.8 1.9-2 4.2-3.2 6.7-2.8 3.2.5 4.9 3.8 3.6 7.1-1.8 4.6-10.3 9.9-10.3 9.9z"
            fill="#ffffff"
          />
          <path
            d="M11.5 13c1.3 0 2.2.8 2.2 1.8 0 .8-.5 1.5-1.5 1.5-1.2 0-2-.8-2-1.8 0-.9.6-1.5 1.3-1.5z"
            fill="url(#love_shine)"
            opacity="0.8"
          />
        </svg>
      )

    case 'CARE':
      return (
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 36 36"
          className={className}
          style={{ verticalAlign: 'middle', display: 'inline-block', ...style }}>
          <defs>
            <radialGradient id="care_bg" cx="35%" cy="30%" r="70%">
              <stop offset="0%" stopColor="#ffe668" />
              <stop offset="65%" stopColor="#f7b125" />
              <stop offset="100%" stopColor="#d98908" />
            </radialGradient>
            <radialGradient id="care_heart" cx="35%" cy="30%" r="70%">
              <stop offset="0%" stopColor="#ff4d6d" />
              <stop offset="100%" stopColor="#c9184a" />
            </radialGradient>
          </defs>
          <circle cx="18" cy="18" r="17" fill="url(#care_bg)" />
          {/* Closed smiling eyes */}
          <path d="M10 14c.8-1.5 2.5-2 3.8-1.2M22.2 12.8c1.3-.8 3-.3 3.8 1.2" stroke="#633900" strokeWidth="1.8" strokeLinecap="round" fill="none" />
          {/* Sweet closed smile */}
          <path d="M14 20c1.2 1.5 2.8 2.2 4 2.2s2.8-.7 4-2.2" stroke="#633900" strokeWidth="1.6" strokeLinecap="round" fill="none" />
          {/* Rosy cheeks */}
          <circle cx="9.5" cy="18" r="2.2" fill="#ff7070" opacity="0.6" />
          <circle cx="26.5" cy="18" r="2.2" fill="#ff7070" opacity="0.6" />
          {/* Hugged mini heart */}
          <path
            d="M18 29.5s-4.5-2.8-5.5-5.2c-.7-1.7.2-3.5 1.9-3.8 1.3-.2 2.5.4 3.6 1.5 1.1-1.1 2.3-1.7 3.6-1.5 1.7.3 2.6 2.1 1.9 3.8-1 2.4-5.5 5.2-5.5 5.2z"
            fill="url(#care_heart)"
          />
          {/* Cute hugging hands */}
          <path d="M12 25c1.5-.8 2.5-.2 3.2.6M24 25c-1.5-.8-2.5-.2-3.2.6" stroke="#f7b125" strokeWidth="2.4" strokeLinecap="round" fill="none" />
          <path d="M12 25c1.5-.8 2.5-.2 3.2.6M24 25c-1.5-.8-2.5-.2-3.2.6" stroke="#633900" strokeWidth="1" strokeLinecap="round" fill="none" />
        </svg>
      )

    case 'HAHA':
      return (
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 36 36"
          className={className}
          style={{ verticalAlign: 'middle', display: 'inline-block', ...style }}>
          <defs>
            <radialGradient id="haha_bg" cx="35%" cy="30%" r="70%">
              <stop offset="0%" stopColor="#ffe668" />
              <stop offset="65%" stopColor="#f7b125" />
              <stop offset="100%" stopColor="#d98908" />
            </radialGradient>
          </defs>
          <circle cx="18" cy="18" r="17" fill="url(#haha_bg)" />
          {/* Laughing closed eyes (><) */}
          <path d="M9 13.5l4 2.5-4 2.5M27 13.5l-4 2.5 4 2.5" stroke="#633900" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          {/* Big open mouth */}
          <path d="M10 21c0 5 3.6 8 8 8s8-3 8-8H10z" fill="#633900" />
          {/* Tongue */}
          <path d="M14.5 25.5c1 .9 2.2 1.5 3.5 1.5s2.5-.6 3.5-1.5c-1-1.2-2.2-1.8-3.5-1.8s-2.5.6-3.5 1.8z" fill="#f33e58" />
          {/* Upper teeth white strip */}
          <path d="M10 21h16v1.5H10z" fill="#ffffff" />
        </svg>
      )

    case 'WOW':
      return (
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 36 36"
          className={className}
          style={{ verticalAlign: 'middle', display: 'inline-block', ...style }}>
          <defs>
            <radialGradient id="wow_bg" cx="35%" cy="30%" r="70%">
              <stop offset="0%" stopColor="#ffe668" />
              <stop offset="65%" stopColor="#f7b125" />
              <stop offset="100%" stopColor="#d98908" />
            </radialGradient>
          </defs>
          <circle cx="18" cy="18" r="17" fill="url(#wow_bg)" />
          {/* Surprised high arched eyebrows */}
          <path d="M9.5 9c1.5-1.5 4-1.5 5.5 0M21 9c1.5-1.5 4-1.5 5.5 0" stroke="#633900" strokeWidth="1.8" strokeLinecap="round" fill="none" />
          {/* Wide open eyes */}
          <ellipse cx="12.5" cy="14" rx="2.4" ry="3.5" fill="#633900" />
          <ellipse cx="23.5" cy="14" rx="2.4" ry="3.5" fill="#633900" />
          <circle cx="11.8" cy="13" r="0.9" fill="#ffffff" />
          <circle cx="22.8" cy="13" r="0.9" fill="#ffffff" />
          {/* Big O mouth */}
          <ellipse cx="18" cy="24.5" rx="4.5" ry="5.8" fill="#633900" />
          <ellipse cx="18" cy="25" rx="3.3" ry="4.5" fill="#2d1700" />
        </svg>
      )

    case 'SAD':
      return (
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 36 36"
          className={className}
          style={{ verticalAlign: 'middle', display: 'inline-block', ...style }}>
          <defs>
            <radialGradient id="sad_bg" cx="35%" cy="30%" r="70%">
              <stop offset="0%" stopColor="#ffe668" />
              <stop offset="65%" stopColor="#f7b125" />
              <stop offset="100%" stopColor="#d98908" />
            </radialGradient>
            <linearGradient id="sad_tear" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#70c0ff" />
              <stop offset="100%" stopColor="#1877f2" />
            </linearGradient>
          </defs>
          <circle cx="18" cy="18" r="17" fill="url(#sad_bg)" />
          {/* Sad drooping eyebrows */}
          <path d="M9 10c2 1.2 4.5 1 6-.2M27 10c-2 1.2-4.5 1-6-.2" stroke="#633900" strokeWidth="1.8" strokeLinecap="round" fill="none" />
          {/* Closed sad curved eyes */}
          <path d="M10 15c1.2 1.5 3 1.5 4.2 0M21.8 15c1.2 1.5 3 1.5 4.2 0" stroke="#633900" strokeWidth="1.8" strokeLinecap="round" fill="none" />
          {/* Down-curved sad mouth */}
          <path d="M13.5 24.5c1.5-1.8 3-2.5 4.5-2.5s3 .7 4.5 2.5" stroke="#633900" strokeWidth="2" strokeLinecap="round" fill="none" />
          {/* Big glistening teardrop */}
          <path
            d="M24.5 17c0 0-1.8 2.5-1.8 3.8a1.8 1.8 0 0 0 3.6 0c0-1.3-1.8-3.8-1.8-3.8z"
            fill="url(#sad_tear)"
          />
          <circle cx="24.2" cy="20" r="0.6" fill="#ffffff" opacity="0.8" />
        </svg>
      )

    case 'ANGRY':
      return (
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 36 36"
          className={className}
          style={{ verticalAlign: 'middle', display: 'inline-block', ...style }}>
          <defs>
            <radialGradient id="angry_bg" cx="35%" cy="30%" r="70%">
              <stop offset="0%" stopColor="#ff7b47" />
              <stop offset="60%" stopColor="#f03e2e" />
              <stop offset="100%" stopColor="#b31217" />
            </radialGradient>
          </defs>
          <circle cx="18" cy="18" r="17" fill="url(#angry_bg)" />
          {/* Sharp inward-slanted furious brows */}
          <path d="M9 10.5l6 3.5M27 10.5l-6 3.5" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round" />
          {/* Intense glaring eyes */}
          <circle cx="13" cy="17" r="2.2" fill="#ffffff" />
          <circle cx="23" cy="17" r="2.2" fill="#ffffff" />
          <circle cx="13.8" cy="16.5" r="1.1" fill="#1e0500" />
          <circle cx="22.2" cy="16.5" r="1.1" fill="#1e0500" />
          {/* Snarl frown mouth */}
          <path d="M12 25.5c1.8-1.8 4-2.5 6-2.5s4.2.7 6 2.5" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" fill="none" />
        </svg>
      )

    default:
      return null
  }
}

/**
 * Danh sách Reaction chuẩn phong cách mạng xã hội với màu sắc và nhãn tương ứng
 */
export const REACTIONS = [
  { key: 'LIKE', label: 'Thích', emoji: '👍', color: '#1877f2' },
  { key: 'LOVE', label: 'Yêu thích', emoji: '❤️', color: '#f33e58' },
  { key: 'CARE', label: 'Thương thương', emoji: '🥰', color: '#f7b125' },
  { key: 'HAHA', label: 'Haha', emoji: '😆', color: '#f7b125' },
  { key: 'WOW', label: 'Wow', emoji: '😮', color: '#f7b125' },
  { key: 'SAD', label: 'Buồn', emoji: '😢', color: '#f7b125' },
  { key: 'ANGRY', label: 'Phẫn nộ', emoji: '😡', color: '#e96630' },
]

/**
 * Danh mục Trạng thái Cảm xúc (Feelings) - thiết kế chuyên nghiệp, icon phong phú
 */
export const FEELINGS = [
  { key: 'PROUD', label: 'Tự hào', text: 'cảm thấy tự hào', emoji: '🌟', color: '#F59E0B' },
  { key: 'HAPPY', label: 'Hạnh phúc', text: 'cảm thấy hạnh phúc', emoji: '😊', color: '#10B981' },
  { key: 'JOYFUL', label: 'Vui vẻ', text: 'cảm thấy vui vẻ', emoji: '😄', color: '#F59E0B' },
  { key: 'BLESSED', label: 'Biết ơn', text: 'cảm thấy biết ơn', emoji: '🙏', color: '#8B5CF6' },
  { key: 'LOVED', label: 'Được yêu thương', text: 'cảm thấy được yêu thương', emoji: '🥰', color: '#EC4899' },
  { key: 'EXCITED', label: 'Hào hứng', text: 'cảm thấy hào hứng', emoji: '🥳', color: '#3B82F6' },
  { key: 'WONDERFUL', label: 'Tuyệt vời', text: 'cảm thấy tuyệt vời', emoji: '😎', color: '#06B6D4' },
  { key: 'RELAXED', label: 'Thư giãn', text: 'cảm thấy thư giãn', emoji: '☕', color: '#B45309' },
  { key: 'MOTIVATED', label: 'Tràn đầy năng lượng', text: 'cảm thấy tràn đầy năng lượng', emoji: '💪', color: '#EF4444' },
  { key: 'LUCKY', label: 'May mắn', text: 'cảm thấy may mắn', emoji: '🍀', color: '#10B981' },
  { key: 'CONFIDENT', label: 'Tự tin', text: 'cảm thấy tự tin', emoji: '✨', color: '#EAB308' },
  { key: 'PASSIONATE', label: 'Nhiệt huyết', text: 'cảm thấy nhiệt huyết', emoji: '🔥', color: '#F97316' },
  { key: 'OPTIMISTIC', label: 'Yêu đời', text: 'cảm thấy yêu đời', emoji: '🌈', color: '#06B6D4' },
  { key: 'PEACEFUL', label: 'Bình yên', text: 'cảm thấy bình yên', emoji: '😇', color: '#6366F1' },
  { key: 'TOUCHED', label: 'Xúc động', text: 'cảm thấy xúc động', emoji: '🥺', color: '#D97706' },
  { key: 'THOUGHTFUL', label: 'Đang suy ngẫm', text: 'đang cảm thấy suy ngẫm', emoji: '🤔', color: '#64748B' },
  { key: 'COOL', label: 'Ngầu', text: 'cảm thấy ngầu', emoji: '🕶️', color: '#334155' },
  { key: 'HOPEFUL', label: 'Hy vọng', text: 'cảm thấy đầy hy vọng', emoji: '🌱', color: '#22C55E' },
  { key: 'NOSTALGIC', label: 'Bồi hồi', text: 'cảm thấy bồi hồi', emoji: '🍂', color: '#C2410C' },
  { key: 'TIRED', label: 'Mệt mỏi', text: 'cảm thấy mệt mỏi', emoji: '😴', color: '#94A3B8' },
  { key: 'SAD', label: 'Buồn', text: 'cảm thấy buồn', emoji: '😢', color: '#64748B' },
]

/**
 * Danh sách Emoji phân loại theo nhóm dành cho Emoji Picker
 */
export const EMOJI_CATEGORIES = [
  {
    key: 'smileys',
    name: 'Mặt cười',
    icon: '😊',
    emojis: [
      '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃',
      '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😋',
      '😛', '😜', '🤪', '😝', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨',
      '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥', '😌', '😔',
      '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '🥵',
      '🥶', '🥴', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐', '😕',
      '😟', '🙁', '😮', '😯', '😲', '😳', '🥺', '😦', '😧', '😨',
      '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞', '😓', '😩',
    ],
  },
  {
    key: 'gestures',
    name: 'Cử chỉ',
    icon: '👍',
    emojis: [
      '👍', '👎', '👏', '🙌', '👐', '🤲', '🤝', '👊', '✊', '🤛',
      '🤜', '🤞', '✌️', '🤟', '🤘', '👌', '🤌', '🤏', '👈', '👉',
      '👆', '👇', '☝️', '✋', '🤚', '🖐️', '🖖', '👋', '🤙', '💪',
      '✍️', '🙏', '👀', '👁️', '👂', '👃', '🧠', '🫀', '🦷', '🦴',
    ],
  },
  {
    key: 'hearts',
    name: 'Trái tim',
    icon: '❤️',
    emojis: [
      '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔',
      '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '💌',
      '💋', '✨', '⭐', '🌟', '💫', '🔥', '💥', '⚡', '☀️', '🌈',
    ],
  },
  {
    key: 'celebration',
    name: 'Biểu tượng',
    icon: '🎉',
    emojis: [
      '🎉', '🎊', '🎈', '🎁', '🏆', '🥇', '🥈', '🥉', '🏅', '🎖️',
      '🎯', '💯', '🚀', '📌', '📍', '🚩', '🔔', '📣', '💬', '💭',
      '💡', '☕', '🍻', '🥂', '🍾', '🍕', '🌸', '🍀', '🌺', '🌻',
    ],
  },
]

/**
 * Helper tách nội dung và metadata cảm xúc (feeling) được nhúng trong content
 */
export const extractPostContentAndFeeling = (rawContent, postFeeling) => {
  if (postFeeling && typeof postFeeling === 'object') {
    return {
      content: rawContent || '',
      feeling: postFeeling,
    }
  }
  if (!rawContent) return { content: '', feeling: null }

  const feelingMatch = rawContent.match(/^<!--feeling:(.*?)-->\s*\n?/)
  if (feelingMatch) {
    try {
      const parsed = JSON.parse(feelingMatch[1])
      const cleanContent = rawContent.substring(feelingMatch[0].length)
      return {
        content: cleanContent,
        feeling: parsed,
      }
    } catch (e) {
      // bỏ qua lỗi parse
    }
  }

  return {
    content: rawContent,
    feeling: null,
  }
}

/**
 * Trình render nội dung văn bản:
 * - Giữ nguyên xuống dòng \n, khoảng trắng (bài thơ, ngắt đoạn)
 * - In đậm: **in đậm** -> <strong>in đậm</strong>
 * - In nghiêng: *in nghiêng* -> <em>in nghiêng</em>
 * - Gắn thẻ: @[Tên người] -> Mention tag xanh
 * - Liên kết: https://... -> Clickable link
 */
export const renderFormattedContent = content => {
  if (!content) return ''

  // Chuyển đổi các thẻ <br> thành ký tự xuống dòng chuẩn nếu có
  const text = content.replace(/<br\s*\/?>/gi, '\n')

  // Regex nhận diện các token đặc biệt:
  // 1: Mention @[...]
  // 2: Link https?://...
  // 3: In đậm **...**
  // 4: In nghiêng *...*
  const tokenRegex = /(@\[[^\]]+\]|https?:\/\/[^\s]+|\*\*[^*]+\*\*|\*[^*]+\*)/g

  const parts = text.split(tokenRegex)

  return parts.map((part, index) => {
    if (!part) return null

    // Gắn thẻ @[Tên]
    if (part.startsWith('@[') && part.endsWith(']')) {
      const name = part.substring(2, part.length - 1)
      return (
        <span
          key={index}
          style={{
            color: '#050505',
            background: 'rgba(24, 119, 242, 0.12)',
            borderRadius: 6,
            padding: '1px 5px',
            fontWeight: 600,
            cursor: 'pointer',
            display: 'inline-block',
          }}>
          {name}
        </span>
      )
    }

    // Liên kết URL
    if (/^https?:\/\//.test(part)) {
      return (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1877f2', wordBreak: 'break-all' }}
          onClick={e => e.stopPropagation()}>
          {part}
        </a>
      )
    }

    // In đậm **text**
    if (part.startsWith('**') && part.endsWith('**') && part.length >= 4) {
      const boldText = part.substring(2, part.length - 2)
      return (
        <strong key={index} style={{ fontWeight: 700, color: 'inherit' }}>
          {boldText}
        </strong>
      )
    }

    // In nghiêng *text*
    if (part.startsWith('*') && part.endsWith('*') && part.length >= 2) {
      const italicText = part.substring(1, part.length - 1)
      return (
        <em key={index} style={{ fontStyle: 'italic', color: 'inherit' }}>
          {italicText}
        </em>
      )
    }

    // Văn bản thông thường (xuống dòng và khoảng trắng sẽ được CSS white-space: pre-wrap giữ nguyên)
    return <React.Fragment key={index}>{part}</React.Fragment>
  })
}

/**
 * Kiểm tra xem nội dung bài viết có chứa mã HTML (do CKEditor sinh ra) hay không
 */
export const isHtmlContent = str => {
  if (!str || typeof str !== 'string') return false
  return /<\/?[a-z][\s\S]*>/i.test(str)
}

/**
 * Lấy văn bản thô từ chuỗi HTML để tính độ dài hiển thị
 */
export const stripHtml = html => {
  if (!html || typeof html !== 'string') return ''
  return html
    .replace(/<\/?[a-z][^>]*>/gi, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\s+/g, ' ')
    .trim()
}

/**
 * Làm sạch hoàn toàn nội dung bài viết (loại bỏ feeling comment, mã HTML, ký tự markdown, mention syntax)
 * để hiển thị bản xem trước văn bản thuần túy gọn gàng, không bị lộ thẻ tag HTML.
 */
export const getCleanPlainText = rawContent => {
  if (!rawContent || typeof rawContent !== 'string') return ''

  return rawContent
    // 1. Loại bỏ toàn bộ HTML comments (bao gồm <!--feeling:...-->)
    .replace(/<!--[\s\S]*?-->/g, '')
    // 2. Chuyển đổi các thẻ khối và ngắt dòng thành khoảng trắng để từ không bị dính
    .replace(/<\/(p|div|h[1-6]|li|blockquote|tr)>/gi, ' ')
    .replace(/<(br|hr)\s*\/?>/gi, ' ')
    // 3. Loại bỏ toàn bộ thẻ HTML còn lại
    .replace(/<[^>]*>/g, '')
    // 4. Giải mã các thực thể HTML phổ biến
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec))
    // 5. Làm sạch cú pháp markdown & mention
    .replace(/@\[([^\]]+)\]/g, '@$1')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/__([^_]+)__/g, '$1')
    .replace(/_([^_]+)_/g, '$1')
    .replace(/~~([^~]+)~~/g, '$1')
    .replace(/`([^`]+)`/g, '$1')
    // 6. Gom khoảng trắng
    .replace(/\s+/g, ' ')
    .trim()
}

